(function () {
  if (window.__stayaiFreeGiftLoaded) return;
  window.__stayaiFreeGiftLoaded = true;

  const STORAGE_KEY = 'stayai_free_gift_registry';
  const registry = new Map(); // productId(string) -> { variantId, titles: [t1,t2,t3] }

  let syncing = false; // true while WE are writing to the cart (ignore our own resulting events)

  /* ---------------------------------------------------------------- */
  /* Registry: which products have a configured free gift              */
  /* ---------------------------------------------------------------- */

  function loadCachedRegistry() {
    try {
      const cached = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      Object.entries(cached).forEach(([productId, config]) => registry.set(productId, config));
    } catch (e) {
      /* ignore malformed cache */
    }
    console.log('bugnbuild ====== loadCachedRegistry', Object.fromEntries(registry));
  }

  function persistRegistry() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.fromEntries(registry)));
      console.log('bugnbuild ====== persistRegistry saved', Object.fromEntries(registry));
    } catch (e) {
      /* ignore quota errors */
    }
  }

  // Gift cart mein nahi hai -> localStorage saaf karo.
  // In-memory registry rehne dete hain, taaki isi page par dobara
  // subscription add ho toh gift config mil jaye.
  function clearStoredRegistry(reason) {
    try {
      if (localStorage.getItem(STORAGE_KEY) === null) return;
      localStorage.removeItem(STORAGE_KEY);
      console.log('bugnbuild ====== clearStoredRegistry cleared', reason);
    } catch (e) {
      /* ignore */
    }
  }

  function collectRegistryFromDom() {
    let changed = false;
    document.querySelectorAll('purchase-options[data-free-gift-variant-id]').forEach((el) => {
      const productId = el.getAttribute('data-free-gift-product-id');
      const variantId = el.getAttribute('data-free-gift-variant-id');
      if (!productId || !variantId) return;

      const config = {
        variantId: String(variantId),
        titles: [
          el.getAttribute('data-free-gift-title-1') || '',
          el.getAttribute('data-free-gift-title-2') || '',
          el.getAttribute('data-free-gift-title-3') || '',
        ],
      };
      const existing = registry.get(String(productId));
      if (!existing || JSON.stringify(existing) !== JSON.stringify(config)) {
        registry.set(String(productId), config);
        changed = true;
      }
    });
    // Note: yahan persist nahi karte. localStorage sirf tab bharta hai
    // jab gift sach mein cart mein add ho (addGiftIfMissing).
    console.log('bugnbuild ====== collectRegistryFromDom', { changed, registry: Object.fromEntries(registry) });
  }

  // Line item properties for the gift line - just the 3 titles
  function giftProperties(config) {
    return {
      'Free gift 1': config.titles[0],
      'Free gift 2': config.titles[1],
      'Free gift 3': config.titles[2],
    };
  }

  function registeredGiftVariantIds() {
    return new Set(Array.from(registry.values()).map((c) => c.variantId));
  }

  /* ---------------------------------------------------------------- */
  /* Cart API helpers                                                   */
  /* ---------------------------------------------------------------- */

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function writeCart(url, body) {
    syncing = true;
    try {
      await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
    } finally {
      syncing = false;
    }
  }

  function changeLine(key, quantity) {
    return writeCart('/cart/change.js', { id: key, quantity });
  }

  function addLine(variantId, quantity, properties) {
    return writeCart('/cart/add.js', { items: [{ id: Number(variantId), quantity, properties }] });
  }

  async function refreshUpcartUI() {
    if (typeof window.upcartRefreshCart !== 'function') return;
    try {
      await window.upcartRefreshCart();
    } catch (err) {
      console.error('[stayai-free-gift] upcartRefreshCart failed', err);
    }
  }

  let giftQueue = Promise.resolve();

  function handleAddedToCart(item) {
    if (!item || syncing) return;

    const productId = String(item.productId);
    const config = registry.get(productId);
    if (!config) return; // not a product we manage a gift for
    if (!item.sellingPlanAllocation) return; // only gift subscribed purchases

    const qtyAdded = item.quantityAdded;
    if (!qtyAdded || qtyAdded <= 0) return;

    giftQueue = giftQueue.then(() => addGiftIfMissing(config));
    return giftQueue;
  }

  async function addGiftIfMissing(config) {
    try {
      const cart = await getCart();
      const giftVariantIds = registeredGiftVariantIds();
      const aGiftAlreadyInCart = (cart.items || []).some((line) =>
        giftVariantIds.has(String(line.variant_id))
      );
      console.log('bugnbuild ====== addGiftIfMissing check', {
        giftVariantIds: Array.from(giftVariantIds),
        cartVariantIds: (cart.items || []).map((i) => i.variant_id),
        aGiftAlreadyInCart,
      });
      if (aGiftAlreadyInCart) return;

      await addLine(config.variantId, 1, giftProperties(config));
      // Gift cart mein aa gaya -> ab localStorage mein save karo,
      // taaki dusre pages (cart page etc.) par bhi cleanup gift pehchaan sake
      persistRegistry();
      await refreshUpcartUI();
    } catch (err) {
      console.error('[stayai-free-gift] gift add failed', err);
    }
  }

  /* ---------------------------------------------------------------- */
  /* Cleanup path: remove gift(s) once no registered subscription        */
  /* remains in the cart                                                 */
  /* ---------------------------------------------------------------- */

  let cleaning = false;

  async function cleanupGiftsIfNoSubscription() {
    if (syncing || cleaning) return;
    cleaning = true;
    try {
      const cart = await getCart();
      const items = cart.items || [];

      const hasActiveRegisteredSubscription = items.some(
        (item) => item.selling_plan_allocation && registry.has(String(item.product_id))
      );
      const giftVariantIds = registeredGiftVariantIds();
      const giftLines = items.filter((item) => giftVariantIds.has(String(item.variant_id)));
      console.log('bugnbuild ====== cleanup check', {
        items: items.map((i) => ({
          product_id: i.product_id,
          variant_id: i.variant_id,
          selling_plan_allocation: i.selling_plan_allocation,
        })),
        hasActiveRegisteredSubscription,
        giftLinesFound: giftLines.length,
      });

      // Gift cart mein hai hi nahi (customer ne khud remove kiya, ya kabhi add hi nahi hua)
      if (giftLines.length === 0) {
        clearStoredRegistry('no gift line in cart');
        return;
      }

      if (hasActiveRegisteredSubscription) return; // still have a subscribed product, keep the gift

      for (const line of giftLines) {
        await changeLine(line.key, 0);
      }
      // Gift remove ho gaya -> localStorage bhi saaf
      clearStoredRegistry('gift removed because no subscription');
      await refreshUpcartUI();
    } catch (err) {
      console.error('[stayai-free-gift] gift cleanup failed', err);
    } finally {
      cleaning = false;
    }
  }

  /* ---------------------------------------------------------------- */
  /* UpCart event wiring                                                */
  /* ---------------------------------------------------------------- */

  function wireUpcartEvents() {
    if (typeof window.upcartSubscribeAddedToCart === 'function') {
      window.upcartSubscribeAddedToCart((event) => {
        handleAddedToCart(event && event.item);
      });
    } else {
      console.warn('[stayai-free-gift] window.upcartSubscribeAddedToCart is not available yet');
    }

    if (typeof window.upcartSubscribeCartUpdated === 'function') {
      window.upcartSubscribeCartUpdated(() => {
        cleanupGiftsIfNoSubscription();
      });
    } else {
      console.warn('[stayai-free-gift] window.upcartSubscribeCartUpdated is not available yet');
    }

    // Customer drawer se gift ka "remove" dabaye -> turant localStorage clear
    if (typeof window.upcartSubscribeItemRemoved === 'function') {
      window.upcartSubscribeItemRemoved((event) => {
        const item = event && event.item;
        if (!item) return;
        const removedVariantId = String(item.variantId || item.variant_id || '');
        console.log('bugnbuild ====== itemRemoved', removedVariantId);
        if (registeredGiftVariantIds().has(removedVariantId)) {
          clearStoredRegistry('customer removed gift from cart');
        }
      });
    }
  }

  /* ---------------------------------------------------------------- */
  /* Boot                                                                */
  /* ---------------------------------------------------------------- */

  document.addEventListener('DOMContentLoaded', () => {
    loadCachedRegistry();
    collectRegistryFromDom();
    wireUpcartEvents();
    cleanupGiftsIfNoSubscription();
  });
})();